import { render, staticRenderFns } from "./PrintExpensesReport.vue?vue&type=template&id=fef41eb8&"
import script from "./PrintExpensesReport.vue?vue&type=script&lang=ts&"
export * from "./PrintExpensesReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports